import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { wrapGrid } from "animate-css-grid";
import "./Grid.scss";

import GridItem from "../GridItem";

const Grid = ({
  items,
  itemsViewType,
  titleWidth,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    wrapGrid(ref.current, { easing: 'backOut', stagger: 10, duration: 400 });
  }, [items, ref.current]);

  return (
    <div
      className={classNames({
        "grid": true,
        "grid-template-columns": itemsViewType === 'block',
      })}
      ref={ref}
    >
      {items.map(item => {
        return (
          <div
            key={item.id}
          >
            <GridItem
              id={item.id}
              item={item}
              titleWidth={titleWidth}
              isBlock={itemsViewType === 'block'}
            />
          </div>
        )
      })}
    </div>
  );
};

export default Grid;
